<template>
  <div>
    <report-panel-collapsible :report="report" :anchor="'keyratios'" :initallyOpen="true">
      <div slot="title">Key Ratios</div>
      <div slot="body">
        <!-- panel content start -->
        <div class="table-responsive">
          <table class="table table-striped table-condensed" id="key-ratios-table">
            <tbody>
              <tr>
                <header-cell />
                <th
                  class="text-right"
                  v-for="(financial, index) of financialReports"
                  :key="financial.id"
                  :class="extraClasses(index, 'accounts_date')"
                >
                  {{ isEmptyMessage(formatDate(financial.accounts_date)) }}
                </th>
              </tr>

              <tr>
                <header-cell>
                  <template slot="heading">Current Ratio:</template>
                </header-cell>
                <simple-cell
                  v-for="(financial, index) of financialReports"
                  :key="financial.id"
                  :displayValue="financial.current_ratio"
                  :extra-classes="extraClasses(index, 'current_ratio')"
                />
              </tr>
              <tr>
                <header-cell>
                  <template slot="heading">Quick Ratio / Acid Test:</template>
                </header-cell>
                <simple-cell
                  v-for="(financial, index) of financialReports"
                  :key="financial.id"
                  :displayValue="financial.quick_ratio_acid_test"
                  :extra-classes="extraClasses(index, 'quick_ratio_acid_test')"
                />
              </tr>
              <tr>
                <header-cell>
                  <template slot="heading">Gross Profit Margin (%):</template>
                </header-cell>
                <simple-cell
                  v-for="(financial, index) of financialReports"
                  :key="financial.id"
                  :displayValue="formatPercentage(financial.gross_profit_margin_percentage)"
                  :extra-classes="extraClasses(index, 'gross_profit_margin_percentage')"
                />
              </tr>

              <tr>
                <header-cell>
                  <template slot="heading">Return on Assets (%):</template>
                </header-cell>
                <simple-cell
                  v-for="(financial, index) of financialReports"
                  :key="financial.id"
                  :displayValue="formatPercentage(financial.return_on_assets_percentage)"
                  :extra-classes="extraClasses(index, 'return_on_assets_percentage')"
                />
              </tr>
              <tr>
                <header-cell>
                  <template slot="heading">Debtor Days:</template>
                </header-cell>
                <simple-cell
                  v-for="(financial, index) of financialReports"
                  :key="financial.id"
                  :displayValue="financial.debtor_days"
                  :extra-classes="extraClasses(index, 'debtor_days')"
                />
              </tr>
              <tr>
                <header-cell>
                  <template slot="heading">Creditor Days:</template>
                </header-cell>
                <simple-cell
                  v-for="(financial, index) of financialReports"
                  :key="financial.id"
                  :displayValue="financial.creditor_days"
                  :extra-classes="extraClasses(index, 'creditor_days')"
                />
              </tr>
            </tbody>
          </table>
        </div>
        <!-- panel content end -->
      </div>
    </report-panel-collapsible>
  </div>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin';
import ReportPanelCollapsible from '@/components/reports/components/ReportPanelCollapsible';
import HeaderCell from '@/components/reports/panels/financials/tablecells/HeaderCell';
import SimpleCell from '@/components/reports/panels/financials/tablecells/SimpleCell';
import financialsMixin from './FinancialsMixin';

export default {
  components: {
    ReportPanelCollapsible,
    HeaderCell,
    SimpleCell,
  },
  mixins: [financialsMixin, toolsMixin],
  props: ['report'],
};
</script>
